<template>
  <div class="md-layout-item title-bread md-size-100">
    <div class="md-group pull-left title">
      AgBi - Región:&nbsp;
    </div>
    <div class="md-group pull-left">
      <drop-down direction="down">
        <md-button slot="title" class="md-button md-info md-sm dropdown-toggle" data-toggle="dropdown">
          {{ regionSelected }}
        </md-button>
        <ul class="dropdown-menu dropdown-menu-left">
          <li v-for="region in regions" :key="region"><a @click="changeSelectedRegion(region)">{{region}}</a></li>
        </ul>
      </drop-down>
    </div>
    <div class="md-group pull-left" style="margin-left:5px;">
      <drop-down direction="down">
        <md-button slot="title" class="md-button md-success md-sm dropdown-toggle" data-toggle="dropdown">
          {{ cropSelected }}
        </md-button>
        <ul class="dropdown-menu dropdown-menu-left">
          <li v-for="crop in crops" :key="crop"><a @click="changeSelectedCrop(crop)">{{crop}}</a></li>
        </ul>
      </drop-down>
    </div>
    <info-icon :message="info[2]"></info-icon>
  </div>
</template>

<script>
import InfoIcon from "../InfoIcon";
export default {
  name: "crops-menu",
  components: {InfoIcon},
  props: ['regions', 'crops', 'regionSelected', 'cropSelected', 'InfoIcon', 'info'],

  methods: {
    changeSelectedRegion(region) {
      this.$emit('update-selected-region', region);
    },
    changeSelectedCrop(crop) {
      this.$emit('update-selected-crop', crop);
    },
  }
}
</script>

<style scoped>
  .title-bread{
    background-color: #ddd ;
    border-radius: 4px;
    padding: 1px 5px;
    font-weight: bold;
    color:#667
  }
  .title-bread .title{
    margin-top:6px;
    display: inline-block;
  }
  .title-bread .crop{
    color: green;
  }
  .title-bread .crop .md-icon{
    color: green;
    font-size:18px !important;
    vertical-align: top;
    margin-top:-1px;
  }

</style>
